import { useHook, useMutationHook } from '../utils/use-hook'
import { mutationFetcher } from '../utils/default-fetcher'
import type { MutationHook, HookFetcherFn } from '../utils/types'
import type { ForgotPasswordHook } from '../types/forgotPassword'
import type { Provider } from '..'

export type UseForgotPassword<
  H extends MutationHook<ForgotPasswordHook<any>> = MutationHook<ForgotPasswordHook>
> = ReturnType<H['useHook']>

export const fetcher: HookFetcherFn<ForgotPasswordHook> = mutationFetcher

const fn = (provider: Provider) => provider.auth?.useForgotPassword!

const useForgotPassword: UseForgotPassword = (...args) => {
  const hook = useHook(fn)
  return useMutationHook({ fetcher, ...hook })(...args)
}

export default useForgotPassword
